import { createContext } from 'react';

type UserBrand = {
  identifier: string;
  name: string;
};

export const ActiveBrandContext = createContext<string | null>(null);
export const UserBrandsContext = createContext<UserBrand[]>([]);
export const SetActiveBrandContext = createContext<React.Dispatch<React.SetStateAction<string>>>(null);